var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPrevBtnFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 29,
    viewBox: "0 0 71 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1599",
    "data-name": "\\uADF8\\uB8F9 1599",
    transform: "translate(-630 -1772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1217",
    "data-name": "\\uADF8\\uB8F9 1217",
    transform: "translate(-244 -372)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_38",
    "data-name": "\\uD0C0\\uC6D0 38",
    transform: "translate(874 2144)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_449",
    "data-name": "\\uD328\\uC2A4 449",
    d: "M4720.387,2380.776l-4.744,4.744,4.744,4.744",
    transform: "translate(-3830.143 -227.276)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    id: "Prev",
    transform: "translate(670 1792.049)",
    fontSize: 16,
    fontFamily: "Pretendard-Regular, Pretendard",
    letterSpacing: "-0.035em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Prev")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrevBtnFull);
export default __webpack_public_path__ + "static/media/icon-PrevBtnFull.c0e8ffbf30805a7ae6489955e0070a81.svg";
export { ForwardRef as ReactComponent };